<template>
  <div style="z-index: 1">
    <b-row>
      <b-col sm="12" class="person">
        <img src="@/assets/question.svg" alt style="fill:rgb(75, 201, 219);" />
        <div class="user">
          <div class="name" v-html="question" style="line-height:1.2"></div>
          <div class="role">Открытый вопрос</div>
        </div>
      </b-col>
    </b-row>
    <template v-if="data.user_answer.text">
      <b-row style="margin-top:20px; padding-left:80px;">
        <b-col sm="10">
          <h6 style="font-weight:bold; font-size:18px">Ваш ответ:</h6>
          <p style="font-size:18px">
            <template v-for="line in data.user_answer.text.split('\n')">
              {{line}}
              <br />
            </template>
          </p>
        </b-col>
      </b-row>
      <b-row style="padding-left:80px;">

        <b-col sm="10" v-if="result" class="result mt-0" v-html="result + '<p><i>Остались вопросы? Обсудите задание в нашей <a target=\'_blank\' href=\'https://www.facebook.com/groups/skillslabgame\'>группе в Facebook</a></i></p>'"></b-col>
      </b-row>
      <b-row style="margin-top:20px; padding-left:80px;" v-if="data.answer_to_comment ">
        <b-col sm="10">
          <div style="display:table; width:100%; ">
            <h6 style="float:left; font-weight:bold; font-size:18px">Оцените чужой ответ: <span style="font-size:12px; font-weight:normal; color:#08a2dc; cursor:pointer;" v-b-tooltip.hover title="Мы не специально усложняем Вам жизнь.
Комментируя других, Вы помогаете в первую очередь себе. Чем глубже Вы анализируете каждую ситуацию, чем больше вариантов решений перебираете — тем лучше Вы запоминаете материал.">(зачем мне это делать?)</span></h6>
            
            <h6
              style="font-weight:normal; float:right; font-weight:bold; font-size:18px"
            >{{data.answer_set.length +1}} из {{data.comment_number}}</h6>
          </div>

          <p>
            <template v-for="line in data.answer_to_comment.text.split('\n')">
              {{line}}
              <br />
            </template>
          </p>
          <b-form-textarea
            v-model="answer"
            id="write_answer"
            no-resize
            rows="4"
            placeholder="Введите свой ответ сюда"
          ></b-form-textarea>
          <p style="margin-bottom:0; font-size:14px;" v-if="!proccess && check_chars<10 && check_chars>0">Пожалуйста, напишите не менее 10 символов</p>
          <b-button
            variant="primary"
            style="margin-top: 10px; color:white; padding:10px 30px;"
            @click="open(data.answer_to_comment.id)"
            :disabled='true'
            v-if="proccess"
          ><b-spinner small style="margin-right:5px" ></b-spinner>Отправить</b-button>
          <b-button
            variant="primary"
            style="margin-top: 10px; color:white; padding:10px 30px;"
            @click="open(data.answer_to_comment.id)"
            :disabled='check_chars>=10?false:true'
            v-if="!proccess"
          >Отправить</b-button>
        </b-col>
      </b-row>
      <b-row style="margin-top:20px; padding-left:80px;" v-if="!data.answer_to_comment && (data.comment_number >0 || data.user_answer.comment_set.length>0 )">
        <b-col sm="10">
          <div style="display:table; width:100%; ">
            <h6
              style="float:left; font-weight:normal; font-size:18px; cursor:pointer; margin-right:15px;"
              :class="{'bold':comment}"
              @click="comment = true"
            >Комментарии мне</h6>

            <h6
              style="font-weight:normal; float:left; font-size:18px;  cursor:pointer"
              :class="{'bold':!comment}"
              @click="comment = false"
            >Мои комментарии</h6>
          </div>
          <template v-if="!data.answer_to_comment && data.user_answer.comment_set.length>0&&comment">
            <p style="margin-top:10px;"><b >Комментарий автора курса</b></p>
            <template v-if="!data.user_answer.comment_requested && !already_asked">
              <p style="margin-bottom:5px;">Вы можете получить ответ от автора курса за 5 <i class="las la-star" style="color:#08a2dc;"></i></p>
              <b-button variant="outline-primary" @click="ask_yura">Запросить</b-button>
              <p><small>Вы можете получать <i class="las la-star" style="color:#08a2dc;"></i> комментируя чужие ответы</small></p>
            </template>
            <template v-if="(data.user_answer.comment_requested || already_asked )&& data.user_answer.character_comment_set.length == 0">
              <p style="margin-bottom:5px;">Скоро здесь появится ответ от автора курса!</p>
            </template>
            <template v-if="data.user_answer.comment_requested && data.user_answer.character_comment_set.length > 0">
              <div
              class="comment result"
            >
              <div style="width:100%; display:table">
                    <div class="user" style="margin-top:0">

                      <img src="https://api.game.skillslab.center/media/avatars/klimenko.jpg" style="border-radius:40px;" alt />
                      <div class="name">Клименко Юрий</div>
                    </div>
                </div>
                <p style="margin-bottom:5px; margin-top:10px" v-html="data.user_answer.character_comment_set[0].text"></p>
              </div>
            </template>
            <p style="margin-top:10px;"><b >Комментарий других участников</b></p>
            <div
              class="comment result"
              v-for="comment in data.user_answer.comment_set"
              :key="comment.id"
            >
            <div style="width:100%; display:table; margin-bottom:10px">
              <div class="user" style="margin-top:0;" >
                  <img :src="'//api.game.skillslab.center'+comment.author.avatar" alt />
                  <div class="name">{{comment.author.last_name}} {{comment.author.first_name}}</div>
                </div>
               </div>
              <p style="font-size:18px; margin-bottom:0 ;">
                <template v-for="line in comment.text.split('\n')">
                  {{line}}
                  <br />
                </template>
              </p>
              <div style="width:100%; display:table">
                
                <star-rating
                  class="mb-4"
                  :show-rating="false"
                  :star-size="24"
                  active-color="#08a2dc"
                  :rating = comment.score?comment.score:0
                  @rating-selected ="setrating($event, comment.id)"
                  style="float: left; margin-bottom: 0 !important; margin-top: 5px;"
                ></star-rating>
               
              </div>
            </div>
            
          </template>
          <template v-if="!data.answer_to_comment && data.user_answer.comment_set.length==0&&comment">
            <p style="margin-top:10px; margin-bottom:5px"><b >Комментарий автора курса</b></p>
            <template v-if="!data.user_answer.comment_requested && !already_asked">
              <p style="margin-bottom:5px;">Вы можете получить ответ от автора курса за 10 <i class="las la-star" style="color:#08a2dc;"></i></p>
              <b-button variant="outline-primary" @click="ask_yura">Запросить</b-button>
              <p><small>Вы можете получать <i class="las la-star" style="color:#08a2dc;"></i> комментируя чужие ответы</small></p>
            </template>
            <template v-if="(data.user_answer.comment_requested || already_asked) && data.user_answer.character_comment_set.length == 0">
              <p style="margin-bottom:5px;">Скоро здесь появится ответ от автора курса!</p>
            </template>
            <template v-if="data.user_answer.comment_requested && data.user_answer.character_comment_set.length > 0">
              <div
              class="comment result"
            >
                <div style="width:100%; display:table">
                    <div class="user">

                      <img src="https://api.game.skillslab.center/media/avatars/klimenko.jpg" style="border-radius:40px;" alt />
                      <div class="name">Клименко Юрий</div>
                    </div>
                </div>
                <p style="margin-bottom:5px; margin-top:10px" v-html="data.user_answer.character_comment_set[0].text"></p>
              </div>
            </template>
            
            <p style="margin-top:10px; margin-bottom:5px;"><b >Комментарий других участников</b></p>
            <p style="">Здесь будут комментарии к Вашему ответу</p>
            
          </template>
          <template v-if="!data.answer_to_comment&&!comment">
            
            <div
              class="comment"
              v-for="comment in data.answer_set"
              :key="comment.id"
            >
            <div style="width:100%; display:table">
                <div class="user">
                  <img :src="'//api.game.skillslab.center'+comment.author.avatar" alt />
                  <div class="name">{{comment.author.last_name}} {{comment.author.first_name}}</div>
                </div>
                
              </div>
              <p style="font-size:18px; margin-bottom:0 ;">
                <template v-for="line in comment.text.split('\n')">{{line}}<br />
                </template>
              </p>
              
              <div class="result" style="margin-left:0; padding-left:10px ">
                <p style="font-size:18px; margin-bottom:0 ;">
                  <template v-for="line in comment.comment_set[0].text.split('\n')">{{line}}<br />
                  </template>
                </p>
                <star-rating
                  class="mb-4"
                  :show-rating="false"
                  :star-size="18"
                  active-color="#08a2dc"
                  :rating = comment.comment_set[0].score?comment.comment_set[0].score:0
                  :read-only = true
                  style="margin-top: 10px;"
                ></star-rating>
              </div>

            </div>
          </template>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row style="margin-top:20px; padding-left:80px;">
        <b-col sm="10">
          <h6>Ваш ответ:</h6>
          <b-form-textarea
            v-model="answer"
            id="write_answer"
            no-resize
            rows="4"
            placeholder="Введите свой ответ сюда"
          ></b-form-textarea>
          <p style="margin-bottom:0; font-size:14px;" v-if="!proccess && check_chars<10 && check_chars>0">Пожалуйста, напишите не менее 10 символов</p>
          <b-button
            variant="primary"
            style="margin-top: 10px; color:white; padding:10px 30px;"
            @click="sendAnswer(data.id)"
            v-if="proccess"
            :disabled="true"
          ><b-spinner small style="margin-right:5px" ></b-spinner>Отправить</b-button>
          <b-button
            variant="primary"
            :disabled="check_chars>=10?false:true"
            style="margin-top: 10px; color:white; padding:10px 30px;"
            @click="sendAnswer(data.id)"
            v-if="!proccess"
          >Отправить</b-button>
          
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import API from "@/api";
import StarRating from "vue-star-rating";

export default {
  props: {
    question: String,
    result: String,
    data: Object
  },
  data() {
    return {
      comment: true,
      answer: "", 
      proccess:false, 
      already_asked: false
    };
  },
  components: {
    StarRating
  },
  watch: {
    data: function (val) {
      this.proccess = false
      this.answer = ''
    },
  },
   computed: {
    // геттер вычисляемого значения
    check_chars: function () {
      return this.answer.length
    }
  },
  methods: {
    ask_yura()
    {
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` }
      };
      const data = new FormData();
      data.append("open_answer", this.data.user_answer.id);
      API.post("api/request_admin_comment/", data, config).then(response => {
        this.$store.state.user.coin -= 10
        this.already_asked = true
      })
      .catch(function (error) {
        if(error.response.status == 401)
        {
          if(error.response.data.error == 'insufficient_funds')
          {
            this.$bvToast.toast('Прокомментируйте чужие ответы', {
              title: 'Недостаточно средств',
              variant: 'danger',
              solid: true
            })
          }
            
        }

      }.bind(this));
      ;

    },
    setrating(value, id)
    {
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` }
      };
      const data = new FormData();
      data.append("comment", id);
      data.append("score", value);
      API.post("api/score_comment/", data, config).then(response => {
        this.$emit("answered");
      });


    },
    sendAnswer(id) {
      //проверка на непустое поле
      if(this.answer != '')
      {
        this.proccess = true
        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` }
        };
        const data = new FormData();
        data.append("text", this.answer);
        data.append("question", id);
        API.post("api/open_answer/", data, config).then(response => {
          this.$emit("answered");
          
        });


      }
      else{
        this.$bvToast.toast('Поле ответа не должно быть пустым', {
          title: 'Не все поля заполнены',
          variant: 'warning',
          solid: true
        })
      }
    },
    open(id) {
      if(this.answer != '')
      {

        this.proccess = true
        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` }
        };
        const data = new FormData();
        data.append("text", this.answer);
        data.append("open_answer", id);
        API.post("api/comment/", data, config).then(response => {
          this.$emit("answered");  
        });

      }
      else{
        this.$bvToast.toast('Поле ответа не должно быть пустым', {
          title: 'Не все поля заполнены',
          variant: 'warning',
          solid: true
        })
      }
      
    }
  }
};
</script>
<style>
.comment {
  margin-top: 20px;
  margin-left: 0;
  padding-left: 15px;
}
.comment .user {
  margin-top: 10px;
  display: table;
  float: left;
}
.comment .user img {
  width: 50px;
  float: left;
}
.comment .user .name {
  font-size: 15px;
  float: left;
  margin-top: 18px;
  margin-left: 5px;
  margin-bottom: 0px;
}
.bold {
  font-weight: bold !important;
}
.body {
  margin-left: 70px;
  z-index: 1;
}

.question {
  margin-bottom: 5px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  padding-top: 1%;
  padding-bottom: 1%;
  padding-left: 0%;
  margin-bottom: 20px;

  color: #4f4f4f;
}
#your_answer {
  margin-left: 0px;
  transition: 10s;
  white-space: pre-wrap;
  display: none;
  color: #4f4f4f;
  margin: 0 5px 0 5px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  padding-top: 1%;
  padding-bottom: 1%;
}

textarea {
  resize: none;
  overflow: auto;
  width: 100%;
  border: 1px solid #b1b1b1;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  padding: 15px;
}
#done {
  float: right;
  color: #a4a4a4;
  font-weight: bold;
  font-size: 18px;
}
.open_answer {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;

  color: #a4a4a4;
}
#other_answers {
  display: none;
}
#where_to_whrite {
  display: block;
}
.title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: #4f4f4f;
}
.name p:last-child
{
  margin-bottom: 0;
}
.user{
  float: left;
  width: calc(100% - 80px);
}
.tooltip .tooltip-inner{
  max-width: 500px !important;

}
</style>